import { useState } from "react";
import { Link } from "react-router-dom";
import CardOptionsMenu from "./CardOptionsMenu";

const CourseCard = ({optionsEnabled = true, onClick, ...props}) => {

  return (
    <div className="shrink-0 basis-[278px] bg-lavender-8 rounded-2xl p-2">
        {optionsEnabled && 
            <CardOptionsMenu onEdit={props.onEdit} onDelete={props.onDelete} />
        }
        <Link
        to={props.link}
        className=" min-h-[205px]"
        onClick={onClick}
        >
        <div className="w-full min-h-[123px] bg-lavender rounded-xl flex items-end p-2 gap-1">
            {props.children}
        </div>
        <div className="py-4 px-2 leading-5">
            <h4 className="font-semibold">{props.title}</h4>
            <p className="opacity-50">{props.description || ""}</p>
        </div>
        </Link>
    </div>
  );
};

export default CourseCard;
